import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";
import { buttonVariants } from "../ui/Button";

const ActionsButton = ({ center = true, className }) => {
  return (
    <div className={cn("flex gap-2 ", { "justify-center": center }, className)}>
      <Link className={cn(buttonVariants(), "max-w-[185px] w-full")} to="#contact">
      Get in Touch
      </Link>
      <Link
        className={cn(
          buttonVariants({ variant: "secondary" }),
          "max-w-[185px] w-full"
        )}
        to="/about-us#team"
      >
        Our Team
      </Link>
    </div>
  );
};

export default ActionsButton;
